import { IFloorPlanModel, ISiteWalkCapture, ISiteWalkMedia, ISiteWalkModel } from '@api/models';
import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

export const getAllFloorPlans = async (clientId: string, projectId: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/floor-plans`
    );
    return data as IFloorPlanModel[];
};

export const getFloorPlan = async (clientId: string, projectId: string, floorPlanId: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/floor-plans/${floorPlanId}`
    );
    return data as IFloorPlanModel;
};

export const createFloorPlan = async (clientId: string, projectId: string, payload: FormData) => {
    const { data } = await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/floor-plans`,
        payload
    );

    return data as IFloorPlanModel;
};

export const updateFloorPlan = async (
    clientId: string,
    projectId: string,
    floorPlanId: string,
    payload: Pick<IFloorPlanModel, 'name' | 'folder' | 'location' | 'status' | 'timezone' | 'storage' | 'imageName'>
) => {
    const { data } = await http.put(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/floor-plans/${floorPlanId}`,
        payload
    );

    return data as IFloorPlanModel;
};

export const updateFloorPlanImage = async (
    clientId: string,
    projectId: string,
    floorPlanId: string,
    payload: FormData
) => {
    const { data } = await http.put(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/floor-plans/${floorPlanId}/image`,
        payload
    );

    return data as IFloorPlanModel;
};

export const deleteFloorPlan = async (clientId: string, projectId: string, floorPlanId: string) => {
    await http.delete(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/floor-plans/${floorPlanId}`
    );
};

// SITEWALK

export const createSiteWalk = async (
    clientId: string,
    projectId: string,
    floorPlanId: string,
    payload: Pick<ISiteWalkModel, 'name' | 'location' | 'siteWalkCapture'>
) => {
    const { data } = await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/floor-plans/${floorPlanId}/site-walks`,
        payload
    );

    return data as ISiteWalkModel;
};

export const getAllSiteWalks = async (clientId: string, projectId: string, floorPlanId: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/floor-plans/${floorPlanId}/site-walks`
    );
    return data as ISiteWalkModel[];
};

export const getSiteWalk = async (clientId: string, projectId: string, floorPlanId: string, siteWalkId: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/floor-plans/${floorPlanId}/site-walks/${siteWalkId}`
    );
    return data as ISiteWalkModel;
};

export const getOldestSiteWalk = async (
    clientId: string,
    projectId: string,
    floorPlanId: string,
    siteWalkId: string
) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/floor-plans/${floorPlanId}/site-walks/oldest/coordinates`,
        {
            params: { currentId: siteWalkId },
        }
    );

    return data as ISiteWalkModel;
};

export const getSiteWalkCaptures = async (clientId: string, projectId: string, floorPlanId: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/floor-plans/${floorPlanId}/site-walk-captures`
    );
    return data as ISiteWalkCapture[];
};

export const deleteSiteWalk = async (clientId: string, projectId: string, floorPlanId: string, siteWalkId: string) => {
    await http.delete(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/floor-plans/${floorPlanId}/site-walks/${siteWalkId}`
    );
};

export const updateSiteWalk = async (
    clientId: string,
    projectId: string,
    floorPlanId: string,
    siteWalkId: string,
    payload: Pick<ISiteWalkModel, 'name' | 'location' | 'trajectory' | 'coordinates' | 'status' | 'folder'>
) => {
    const { data } = await http.patch(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/floor-plans/${floorPlanId}/site-walks/${siteWalkId}`,
        payload
    );

    return data as ISiteWalkModel;
};

export const editSiteWalk = async (
    clientId: string,
    projectId: string,
    floorPlanId: string,
    siteWalkId: string,
    payload: Pick<ISiteWalkModel, 'name' | 'location' | 'siteWalkCapture'>
) => {
    const { data } = await http.patch(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/clients/${clientId}/projects/${projectId}/floor-plans/${floorPlanId}/site-walks/${siteWalkId}`,
        payload
    );

    return data as ISiteWalkModel;
};
